// extracted by css-extract-rspack-plugin
export default {"menuTrigger":"menuTrigger-q9ZXRw"};